import { faFolderBlank } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const NoData = ({ isNotFound, message = "No data available" }) => {
  if (!isNotFound) return null;

  return (
    <tr>
      <td colSpan={100} className="text-center py-6 text-gray-500">
        <div className="flex flex-col items-center justify-center">
          <FontAwesomeIcon icon={faFolderBlank} className="text-xl" />
          <p className="text-lg font-medium">{message}</p>
        </div>
      </td>
    </tr>
  );
};

export default NoData;
